import { FC } from 'react';

import { ExposureDetailsTable } from './ExposureDetailsTable';
import { MacroDetailsTable } from './MacroDetailsTable';
import { MetricDetailsTable } from './MetricDetailsTable';
import { ModelDetailsTable } from './ModelDetailsTable';
import { ResourceDetailsParams } from './panelDetailTypes';
import { PublicModelDetailsTable } from './PublicModelDetailsTable';
import { SavedQueryDetailsTable } from './SavedQueryDetailsTable';
import { SeedDetailsTable } from './SeedDetailsTable';
import { SemanticModelDetailsTable } from './SemanticModelDetailsTable';
import { SnapshotDetailsTable } from './SnapshotDetailsTable';
import { SourceDetailsTable } from './SourceDetailsTable';
import { TestDetailsTable } from './TestDetailsTable';

export type GeneralResourceTableProps = ResourceDetailsParams & {
  compact?: boolean;
  isExternalModel?: boolean;
  showAutoExposureActions?: boolean;
};

export const GeneralResourceTable: FC<GeneralResourceTableProps> = (panelProps) => {
  switch (panelProps.uniqueId.resourceType) {
    case 'model':
      if (panelProps.isExternalModel) {
        return <PublicModelDetailsTable {...panelProps} />;
      }
      return <ModelDetailsTable {...panelProps} />;

    case 'source':
      return <SourceDetailsTable {...panelProps} />;
    case 'snapshot':
      return <SnapshotDetailsTable {...panelProps} />;
    case 'macro':
      return <MacroDetailsTable {...panelProps} />;
    case 'unit_test':
    case 'test':
      return <TestDetailsTable {...panelProps} />;
    case 'exposure':
      return <ExposureDetailsTable {...panelProps} />;
    case 'metric':
      return <MetricDetailsTable {...panelProps} />;
    case 'seed':
      return <SeedDetailsTable {...panelProps} />;
    case 'semantic_model':
      return <SemanticModelDetailsTable {...panelProps} />;
    case 'saved_query':
      return <SavedQueryDetailsTable {...panelProps} />;
    default:
      return null;
  }
};
